import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { BaseMapIcon } from '../../svg';

interface IProps {
    className?: string;
    onClick(): void;
}

const BaseShowMapButton: React.FC<IProps> = ({ className, onClick }) => {
    const { t } = useTranslation();

    return (
        <div className={className} role="button" onClick={onClick}>
            <span>{t('appointment.showMap')}</span>
            <BaseMapIcon />
        </div>
    );
};

export const ShowMapButton = styled(BaseShowMapButton)`
    color: ${({ theme }) => theme.palette.primary.main};
    cursor: pointer;
    display: flex;
    align-items: center;

    span {
        margin-right: 10px;
        font-size: ${({ theme }) => theme.typography.body1.fontSize};
    }

    svg {
        width: 22px;
        height: 22px;
        cursor: pointer;
        fill: ${({ theme }) => theme.palette.primary.main};
    }
`;
